module.exports = __webpack_public_path__ + "img/circle.67a90a90.png";